import { posterUrl, profileUrl } from '../api/tmdb'
import BrandLogo from './BrandLogo'
import BottomNav from './BottomNav'
import { IconArrowLeft, IconHome, IconClapper } from './icons'

const formatTime = (secs) => {
  const m = Math.floor(secs / 60).toString().padStart(2, '0')
  const s = (secs % 60).toString().padStart(2, '0')
  return `${m}:${s}`
}

const PLACEHOLDER = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='185' height='278' viewBox='0 0 185 278'%3E%3Crect fill='%23333' width='185' height='278'/%3E%3Ccircle fill='%23555' cx='92' cy='100' r='40'/%3E%3Cellipse fill='%23555' cx='92' cy='220' rx='60' ry='50'/%3E%3C/svg%3E"

export default function FilmStripReview({ dailyNumber, completedData, onViewStats, onBack, onHome }) {
  const { chain = [], moves, timeSeconds, time, hintsUsed = 0 } = completedData ?? {}
  const displayTime = timeSeconds != null ? formatTime(timeSeconds) : (time ?? '--:--')

  return (
    <div className="film-review">
      <div className="screen-content">
        <div className="film-review__title"><BrandLogo /></div>
        <p className="film-review__label">Daily #{dailyNumber} — Your Chain</p>

        <div className="film-review__score">
          <span>{moves} hops</span>
          <span className="film-review__score-sep">·</span>
          <span>{displayTime}</span>
          {hintsUsed > 0 && (
            <>
              <span className="film-review__score-sep">·</span>
              <span>{Array.from({ length: hintsUsed }).map((_, i) => <IconClapper key={i} size={13} style={{ verticalAlign: 'middle' }} />)} hints</span>
            </>
          )}
        </div>

        <div className="film-review__chain">
          {chain.map((item, i) => (
            <div key={i} className="film-review__chain-item">
              {i > 0 && <span className="film-review__arrow">→</span>}
              {item.type === 'actor' ? (
                <div className="film-review__node film-review__node--actor">
                  <img
                    src={item.profile_path ? profileUrl(item.profile_path, 'w185') : PLACEHOLDER}
                    alt={item.name}
                    onError={(e) => { e.target.src = PLACEHOLDER }}
                  />
                  <span>{item.name}</span>
                </div>
              ) : (
                <div className="film-review__node film-review__node--movie">
                  {item.poster_path ? (
                    <img src={posterUrl(item.poster_path, 'w92')} alt={item.title} />
                  ) : (
                    <div className="film-review__node-placeholder" />
                  )}
                  <span>{item.title}</span>
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="film-review__actions">
          <button className="btn-primary" onClick={onViewStats}>See Stats →</button>
        </div>

        <BottomNav items={[
          { key: 'parent', icon: IconArrowLeft, label: 'Daily', variant: 'inverse', onClick: onBack },
          { key: 'home',   icon: IconHome,      label: 'Home',  variant: 'primary', onClick: onHome },
        ]} />
      </div>
    </div>
  )
}
